import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal } from 'react-bootstrap'

import { setCRT } from "./actions";

const crt = [
  {
    code: 1,
    description: "MEI"
  },
  {
    code: 1,
    description: "Simples Nacional"
  },
  {
    code: 1,
    description: "Simples com Excesso de SUBLIMITE"
  },
  {
    code: 3,
    description: "Lucro Presumido"
  },
  {
    code: 3,
    description: "Lucro Real"
  }
];

class CRT extends Component {
  constructor(props) {
    super(props);
    this.state = { modalError: false };
  }

  UNSAFE_componentWillMount() { }
  render() {
    return (
      <div className="" data-ctr >
        <p className="mb-0 mt-2">CRT (Código do Regime Tributário)</p>
        <select
          id='crt-comp'
          onChange={e => {
            let code = crt[e.target.selectedIndex - 1].code


            if (code == 3) {
              this.setState({ ...this, modalError: true })
              document.getElementById('crt-comp').selectedIndex = 0
              code = null
            }

            this.props.setCRT(code);
          }}
          className="form-control"
        >
          <option
            selected
            disabled
          >Selecione o CRT</option>
          {crt.map(item => (
            <option
              key={item.code}
              value={item.code}
              defaultValue={this.props.crt === item.code}>
              {item.description}
            </option>
          ))}
        </select>
        <p className="pt-2">
          Clique <a target="_blank" href="https://otimizeseunegocio.com/gestao-organizacao/regismes_tributarios_no_brasil_simples_lucro_real_lucro_presumido/">aqui </a> para entender as diferenças entre os regimes tributários brasileiros.
        </p>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  crt: state.crt,
  type: state.personType
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCRT
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CRT);



// WEBPACK FOOTER //
// ./src/components/parts/company-data/crt.jsx